import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { MapPin, ArrowRight } from 'lucide-react';
import { getCityPagesForService } from '@/data/localServiceData';

const ProudlyServingSection = ({ serviceSlug }) => {
  const cityPages = getCityPagesForService(serviceSlug);

  return (
    <section className="py-16 bg-secondary text-secondary-foreground" data-testid="proudly-serving-section">
      <div className="container-custom">
        <div className="text-center mb-8">
          <Badge className="mb-4 bg-primary/20 text-primary border-primary/30">
            <MapPin className="h-3 w-3 mr-1" />
            Service Areas
          </Badge>
          <h2 className="text-2xl sm:text-3xl font-bold mb-3">
            Proudly Serving the <span className="text-gradient-cyan">Hill Country</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto text-sm">
            We provide expert glass services throughout the Texas Hill Country. Find your local service page below.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {cityPages.map((page) => (
            <Link
              key={page.citySlug}
              to={page.path}
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 text-sm font-medium text-white hover:border-primary hover:text-primary transition-colors shadow-sm"
            >
              <MapPin className="h-3 w-3" />
              {page.cityName}
              <ArrowRight className="h-3 w-3" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProudlyServingSection;
